import React from 'react';
import { Bell } from 'lucide-react';

const NotificationBanner = ({ hasNewRecords, isOnFirstPage, onGoToFirstPage, onDismiss }) => {
  if (!hasNewRecords || isOnFirstPage) return null;

  return (
    <div className="bg-blue-50 border-l-4 border-pest-blue p-4 rounded-lg mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Bell className="text-pest-blue mr-2" size={20} />
          <p className="text-pest-blue font-medium">
            New invoices were imported! 
            <button 
              onClick={onGoToFirstPage}
              className="ml-2 underline hover:no-underline"
            >
              Go to page 1
            </button> to see them.
          </p>
        </div>
        <button 
          onClick={onDismiss}
          className="text-gray-400 hover:text-gray-600"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;